import { mergeLeft } from '@bagonboard/wiseman';
import { Button } from '@material-ui/core';
import { Form, Formik } from 'formik';
import { useSnackbar } from 'notistack';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { fetchPost } from '../../../providers/Fetch';
import { ClientInformation, ConfirmationModal, FlightSearch } from './components';
import { INITIAL_VALUES, validationSchema } from './constants';
import { useOrderCreationStyle } from './style';
import { buildService } from './utils';

const OrderCreation = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const flightProducts = useSelector(state => state.flightProducts.data);
  const history = useHistory();
  const [{ isRequesting, onConfirm }, setState] = useState({
    isRequesting: false,
    onConfirm   : undefined,
  });
  const classes = useOrderCreationStyle();
  const closeConfirmationModal = useCallback(
    () => {
      setState(mergeLeft({ onConfirm: undefined, isRequesting: false }));
    },
    [setState]
  );

  const mergeState = useCallback(newState => setState(mergeLeft(newState)), [setState]);

  const onSubmit = (values, { setSubmitting, submitForm }) => {
    const newAPIRequest = async () => {
      try {
        const order = {
          customer: values.client,
          referral: 'BOB',
          services: [buildService(values, flightProducts)],
        };
        mergeState({
          onConfirm   : undefined,
          isRequesting: true,
        });
        const { _id: newOrderId } = await fetchPost('/order', order);
        if (!newOrderId) {
          throw Error('Invalid response from the server');
        }
        setSubmitting(false);
        mergeState({
          isRequesting: false,
        });
        history.push(`/order/${newOrderId}`);
      } catch (e) {
        setSubmitting(false);
        mergeState({
          isRequesting: false,
        });

        enqueueSnackbar(e.message, {
          variant: 'error',
          persist: true,
          action : notificationId => (
            <>
              <Button
                onClick={() => {
                  closeSnackbar(notificationId);
                  submitForm();
                }}
              >
                Retry
              </Button>
              <Button
                onClick={() => {
                  closeSnackbar(notificationId);
                }}
              >
                Close
              </Button>
            </>
          ),
        });
      }
    };
    mergeState({
      onConfirm: newAPIRequest,
    });
  };

  return (
    <>
      <Formik
        initialValues={INITIAL_VALUES}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        <Form className={classes.form}>
          <ClientInformation />
          <FlightSearch isRequesting={isRequesting} />
        </Form>
      </Formik>
      <ConfirmationModal
        isOpen={onConfirm !== undefined}
        cancel={closeConfirmationModal}
        confirm={onConfirm}
      />
    </>
  );
};

export default OrderCreation;
